import React from 'react';
import "./Master.css";
import Sidebar from "../../Component/sidebar/sidebar";
import Header from "../../Component/header/Header.jsx";
import Activity from '../../Component/sub-master/Activity';

function Master() {
    return(
        <div className="container">
            <div className="row row-cols-2">
                {/* sidebar section */}
                <div className="col-2 sidebar">
                    <Sidebar />
                </div>

                {/* content section */}
                <div className="col-10 content">
                    {/* Header */}
                    <Header title = {"Master"} />

                    {/* sub-master */}
                    <Activity />
                </div>
            </div>
        </div>
    )
};

export default Master ;